import { ColumnState } from "ag-grid-community";
import { DateRange } from "react-day-picker";
import { create } from "zustand";
import { PRD3060_R01DetailDto, PRD3060_R01Dto } from "./Dto_PRD3060_R01";
import { getCurrentMonthDateRange } from "src/utils/date/dateUtils";
export interface PRD3060_R01Filter {
    compCd: string;
    compNm: string;
    productDt: DateRange | undefined;
    brandCd: string;
    outputDt: Date | undefined;
}

const defaultDateRange: DateRange = getCurrentMonthDateRange();
const getToday = () => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), today.getDate());
};

export const defaultPRD3060_R01Filter: PRD3060_R01Filter = {
    compCd: "",
    compNm: "",
    productDt: defaultDateRange,
    brandCd: "",
    outputDt: getToday(),
};

export interface Store_PRD3060_R01 {
    PRD3060_R01Filter: PRD3060_R01Filter;
    PRD3060_R01PastFilter: PRD3060_R01Filter;
    setPRD3060_R01Filter: (filter: PRD3060_R01Filter) => void;
    setPRD3060_R01PastFilter: (filter: Partial<PRD3060_R01Filter>) => void;

    PRD3060_R01List: PRD3060_R01Dto[];
    setPRD3060_R01List: (list: PRD3060_R01Dto[]) => void;

    PRD3060_R01DetailList: PRD3060_R01DetailDto[];
    setPRD3060_R01DetailList: (list: PRD3060_R01DetailDto[]) => void;

    selectedPRD3060_R01List: string[];
    setSelectedPRD3060_R01List: (no: string[]) => void;

    allCount: number;
    setAllCount: (count: number) => void;

    columnState: ColumnState[] | null;
    setColumnState: (state: ColumnState[] | null) => void;
    detailColumnState: ColumnState[] | null;
    setDetailColumnState: (state: ColumnState[] | null) => void;

    scrollTop: number | null;
    setScrollTop: (top: number | null) => void;
    detailScrollTop: number | null;
    setDetailScrollTop: (top: number | null) => void;

    initData: () => void;
}

export const usePRD3060_R01Store = create<Store_PRD3060_R01>((set) => ({
    PRD3060_R01Filter: defaultPRD3060_R01Filter,
    PRD3060_R01PastFilter: defaultPRD3060_R01Filter,
    setPRD3060_R01Filter: (filter) => set({ PRD3060_R01Filter: filter }),
    setPRD3060_R01PastFilter: (filter) =>
        set((state) => ({ PRD3060_R01PastFilter: { ...state.PRD3060_R01PastFilter, ...filter } })),

    PRD3060_R01List: [],
    setPRD3060_R01List: (list) => set({ PRD3060_R01List: list }),

    PRD3060_R01DetailList: [],
    setPRD3060_R01DetailList: (list) => set({ PRD3060_R01DetailList: list }),

    selectedPRD3060_R01List: [],
    setSelectedPRD3060_R01List: (no: string[]) =>
        set({ selectedPRD3060_R01List: no, detailScrollTop: null }),

    allCount: 0,
    setAllCount: (count) => set({ allCount: count }),

    columnState: null,
    setColumnState: (state) => set({ columnState: state }),
    detailColumnState: null,
    setDetailColumnState: (state) => set({ detailColumnState: state }),

    scrollTop: null,
    setScrollTop: (top) => set({ scrollTop: top }),
    detailScrollTop: null,
    setDetailScrollTop: (top) => set({ detailScrollTop: top }),

    initData: () =>
        set({
            PRD3060_R01Filter: defaultPRD3060_R01Filter,
            PRD3060_R01PastFilter: defaultPRD3060_R01Filter,
            PRD3060_R01List: [],
            PRD3060_R01DetailList: [],
            selectedPRD3060_R01List: [],
            allCount: 0,
            columnState: null,
            detailColumnState: null,
            scrollTop: null,
            detailScrollTop: null,
        }),
}));
